/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { SSOUXMode } from './SSOUXMode';
import {
    SSOUXModeFromJSON,
    SSOUXModeFromJSONTyped,
    SSOUXModeToJSON,
} from './SSOUXMode';

/**
 * 
 * @export
 * @interface SAMLMethodOptions
 */
export interface SAMLMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof SAMLMethodOptions
     */
    method: FactorMethod;
    /**
     * 
     * @type {string}
     * @memberof SAMLMethodOptions
     */
    provider_credentials_id: string;
    /**
     * 
     * @type {SSOUXMode}
     * @memberof SAMLMethodOptions
     */
    ux_mode?: SSOUXMode;
    /**
     * URL to redirect to after login at the third-party IdP.
     * @type {string}
     * @memberof SAMLMethodOptions
     */
    redirect_target?: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLMethodOptions
     */
    pkce_code_challenge?: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLMethodOptions
     */
    csrf_token?: string;
}

/**
 * Check if a given object implements the SAMLMethodOptions interface.
 */
export function instanceOfSAMLMethodOptions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "method" in value;
    isInstance = isInstance && "provider_credentials_id" in value;

    return isInstance;
}

export function SAMLMethodOptionsFromJSON(json: any): SAMLMethodOptions {
    return SAMLMethodOptionsFromJSONTyped(json, false);
}

export function SAMLMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAMLMethodOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
        'provider_credentials_id': json['provider_credentials_id'],
        'ux_mode': !exists(json, 'ux_mode') ? undefined : SSOUXModeFromJSON(json['ux_mode']),
        'redirect_target': !exists(json, 'redirect_target') ? undefined : json['redirect_target'],
        'pkce_code_challenge': !exists(json, 'pkce_code_challenge') ? undefined : json['pkce_code_challenge'],
        'csrf_token': !exists(json, 'csrf_token') ? undefined : json['csrf_token'],
    };
}

export function SAMLMethodOptionsToJSON(value?: SAMLMethodOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'method': FactorMethodToJSON(value.method),
        'provider_credentials_id': value.provider_credentials_id,
        'ux_mode': SSOUXModeToJSON(value.ux_mode),
        'redirect_target': value.redirect_target,
        'pkce_code_challenge': value.pkce_code_challenge,
        'csrf_token': value.csrf_token,
    };
}

